import type { GlobalThemeOverrides } from 'naive-ui'
import { computed, watch } from 'vue'
import { darkTheme, useOsTheme } from 'naive-ui'
import { useAppStore } from '@/store'
import { useBasicLayout } from '@/hooks/useBasicLayout'

export function useTheme() {
  const appStore = useAppStore()

  const OsTheme = useOsTheme()

  const isDark = computed(() => {
    if (appStore.theme === 'auto')
      return OsTheme.value === 'dark'
    else
      return appStore.theme === 'dark'
  })

  const theme = computed(() => {
    return isDark.value ? darkTheme : undefined
  })

  const themeOverrides = computed<GlobalThemeOverrides>(() => {

		 // 亮色模式下的Select样式
		 const lightSelectOverrides = {
      Select: {
        borderHover: '1px solid #4098fc',
        borderFocus: '1px solid #4098fc',
        boxShadowFocus: '0 0 0 2px rgba(64, 152, 252, 0.2)',
        borderActive: '1px solid #4098fc',
        boxShadowActive: '0 0 0 2px rgba(64, 152, 252, 0.2)',
        borderRadius: '4px',
        heightMedium: '40px',
        // 其他亮色模式下的Select样式
      }
    }

		  // 暗色模式下的Select样式
			const darkSelectOverrides = {
				Select: {
					borderHover: '1px solid #4098fc',
					borderFocus: '1px solid #4098fc',
					boxShadowFocus: '0 0 0 2px rgba(64, 152, 252, 0.2)',
					borderActive: '1px solid #4098fc',
					boxShadowActive: '0 0 0 2px rgba(64, 152, 252, 0.2)',
					borderRadius: '4px',
					heightMedium: '40px',
					// 其他暗色模式下的Select样式
				}
			}

    if (isDark.value) {
      return {
				...darkSelectOverrides,
        common: {},
      }
    }



    return {...lightSelectOverrides}
  })
  const { isMobile } = useBasicLayout()
  watch(
    () => isDark.value,
    (dark) => {
      if (dark)
        document.documentElement.classList.add('dark')
      else
        document.documentElement.classList.remove('dark')
    },
    { immediate: true },
  )
  watch(
    () => isMobile.value,
    (dark) => {
      if (dark)
        document.documentElement.classList.add('is-mobile')
      else
        document.documentElement.classList.remove('is-mobile')
    },
    { immediate: true },
  )

  return { theme, themeOverrides }
}
